import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "../utils/cn.js";
const SPACING = {
    none: "",
    sm: "my-2",
    md: "my-4",
    lg: "my-8",
};
export function Hairline({ spacing = "none", className, ...rest }) {
    return (_jsx("hr", { "data-slot": "hairline", className: cn("h-px border-0 bg-ink-200", SPACING[spacing], className), ...rest }));
}
